var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"equation-viewer"},[(_vm.value == '-')?_c('div',[_vm._v(_vm._s(_vm.value))]):_c('div',[_c('math-field',{class:'math-field '+_vm.size,staticStyle:{"display":"inline-block","font-style":"normal","--caret":"53"},attrs:{"read-only":""}},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }